import api from '../lib/api'

export type AuthorDisplayPreference = 'full_name' | 'username' | 'anonymous'

export interface UserProfile {
  department?: string
  can_manage_documents?: boolean
  author_display_preference?: AuthorDisplayPreference
  notify_on_share?: boolean
  notify_on_participant_join?: boolean
}

export interface UserMe {
  id: number
  username: string
  first_name: string
  last_name: string
  email: string
  profile?: UserProfile
}

export interface UserListItem {
  id: number
  first_name: string
  last_name: string
  full_name: string
  email: string
  phone: string
}

export const userService = {
  async getMe(): Promise<UserMe> {
    const { data } = await api.get<UserMe>('/api/users/me/')
    return data
  },

  async updateMe(payload: Partial<UserMe>): Promise<UserMe> {
    const { data } = await api.patch<UserMe>('/api/users/me/', payload)
    return data
  },

  async changePassword(current_password: string, new_password: string) {
    await api.post('/api/users/change-password/', {
      current_password,
      new_password,
    })
  },

  async listUsers(search = ''): Promise<UserListItem[]> {
    const params = search ? { search } : undefined
    const { data } = await api.get<UserListItem[]>('/api/users/list/', {
      params,
    })
    return data
  },
}

export default userService
